import { TFunction } from 'i18next';
import { PropertyNameError } from '../../integrations/lavva/types/errors';

export const parseErrorCode = (error: PropertyNameError, t: TFunction<'backend-validation', undefined>) => {
  const errorCode = error.ErrorCode;

  if (errorCode.includes('NOT_INCLUSIVE_BETWEEN')) {
    return t('BETWEEN_VALIDATOR', {
      from: error.FormattedMessagePlaceholderValues?.From,
      to: error.FormattedMessagePlaceholderValues?.To,
    });
  }

  return errorCode;
};
